import { GEM_BID_LIST, GEM_ENABLE_FILTER_LIST, INSERT_FILTER, MINISTRY_LIST, ORGANIZATION_LIST, ADD_BID_TO_FAVOURITE, ADD_CUSTOMER_DATA,PENDING_GEM_BID_LIST,COMPLETED_GEM_BID_LIST, CUSTOMER_LIST, GEM_BID_DATA_DONE,ADD_GEM_BID_DATA_DETAILS } from "./ActionType";

const initialValue = {
    gembidlist: [],
    gemenalbefilterlist: [],
    ministrylist: [],
    customerlist: [],
    organizationlist: [],
    insertfilter: [],
    addcustomerdata: [],
    addbidtofavourite: [],
    pendingGemBidList: [],
    addgembiddatadetails: [],
    gembiddatadone: [],
    completedGemBidList: [],
}

export const gemReducer = (store = initialValue, { type, payload }) => {
    if (type === GEM_BID_LIST) {
        return {
            ...store,
            gembidlist: payload.bidResponseList || [],
        };
    } else if (type === GEM_ENABLE_FILTER_LIST) {
        return {
            ...store,
            gemenalbefilterlist: payload.gemEnableFiltersDtoList || [],
        };
    } else if (type === INSERT_FILTER) {
        return {
            ...store,
            insertfilter: payload
        };
    } else if (type === MINISTRY_LIST) {
        return {
            ...store,
            ministrylist: Array.isArray(payload) ? payload : [],
        };
    } else if (type === CUSTOMER_LIST) {
        return {
            ...store,
            customerlist: Array.isArray(payload) ? payload : [],
        };
    } else if (type === ORGANIZATION_LIST) {
        return {
            ...store,
            organizationlist: Array.isArray(payload) ? payload : [],
        };
    } else if (type === ADD_BID_TO_FAVOURITE) {
        return {
            ...store,
            addbidtofavourite: payload
        };
    } else if (type === PENDING_GEM_BID_LIST) {
        return {
            ...store,
            pendingGemBidList: payload.gemBidDataList || [],
        };
    }
     else if (type === COMPLETED_GEM_BID_LIST) {
        return {
            ...store,
            completedGemBidList: payload.gemBidDataList || [],
        };
    } else if (type === ADD_GEM_BID_DATA_DETAILS) {
        return {
            ...store,
            addgembiddatadetails: payload
        };
    } else if (type === GEM_BID_DATA_DONE) {
        return {
            ...store,
            gembiddatadone: payload
        };
    } else if (type === ADD_CUSTOMER_DATA) {
        return {
            ...store,
            addcustomerdata: payload
        };
    }
    return store;
};
